import { useUserStore } from '@/stores/user.store';
import { companyDetailsRoutes } from '@/features/client/company-details';

export default {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Global/GenericDashboardView.vue'),
    redirect: () => {
        const userStore = useUserStore();
        const n = userStore.type === 'bookkeeper' ? 'advisor' : userStore.type;
        const name = `${n}-dashboard`;
        return { name };
    },
    meta: {
        private: true,
        title: 'DASHBOARD',
    },
    children: [
        {
            path: 'client',
            children: [
                {
                    path: '',
                    name: 'client-dashboard',
                    component: () => import('@/features/client/dashboard'),
                },
                {
                    path: 'shop-deals',
                    name: 'client-shop-deals',
                    meta: { title: 'SHOP_DEALS' },
                    component: () => import('@/features/client/shop-deals'),
                },
                {
                    path: 'my-products',
                    name: 'client-my-products',
                    meta: { title: 'MY_PRODUCTS' },
                    component: () => import('@/features/client/my-products'),
                },
                companyDetailsRoutes,
                {
                    path: 'jobs',
                    name: 'client-jobs',
                    component: () => import('@/components/Client/Dashboard/ClientJobs.vue'),
                },
                {
                    path: 'organizations',
                    name: 'client-organizations',
                    component: () => import('@/components/Admin/views/AdminOrganizations.vue'),
                },
                {
                    path: 'entities',
                    name: 'client-entities',
                    component: () => import('@/components/Client/Dashboard/ClientEntities.vue'),
                },
                {
                    path: 'contracts',
                    name: 'client-contracts',
                    // component: () => import('@/components/Client/Dashboard/Contracts/ContractsOverview.vue'),
                    component: () => import('@/features/client/contracts'),
                },
                {
                    path: 'old-contracts',
                    name: 'old-client-contracts',
                    component: () => import('@/components/Client/Dashboard/Contracts/ContractsOverview.vue'),
                    // component: () => import('@/features/client/contracts'),
                },
                {
                    path: 'templates',
                    name: 'client-templates',
                    component: () => import('@/components/Client/Dashboard/ClientTemplates.vue'),
                },
                {
                    path: 'invoices',
                    name: 'client-invoices',
                    component: () => import('@/components/Client/Dashboard/ClientInvoices.vue'),
                },
                {
                    path: 'banking',
                    name: 'client-banking',
                    component: () => import('@/components/Client/Dashboard/ClientBanking.vue'),
                },
                {
                    path: 'bookkeeping',
                    name: 'client-bookkeeping',
                    component: () => import('@/components/Client/Dashboard/ClientBookkeeping/ClientBookkeeping.vue'),
                },
                {
                    path: 'hosting',
                    name: 'client-hosting',
                    component: () => import('@/components/Client/Dashboard/ClientHosting.vue'),
                },
                {
                    path: 'payment-solutions',
                    name: 'client-payment-solutions',
                    component: () => import('@/components/Client/Dashboard/ClientPaymentSolutions.vue'),
                },
                {
                    path: 'dga-services',
                    name: 'client-dga-services',
                    component: () => import('@/components/Client/Dashboard/DgaSalary/PageServices.vue'),
                },
                {
                    path: 'dga-salary-admin',
                    name: 'client-dga-salary-admin',
                    component: () => import('@/components/Client/Dashboard/DgaSalary/PageDgaSalaryAdministration.vue'),
                },
                {
                    path: 'zebra-legal',
                    name: 'client-zebra-legal',
                    component: () => import('@/components/Client/Dashboard/ZebraLegal/PageZebraLegal.vue'),
                },
                {
                    path: 'tasks',
                    name: 'client-tasks',
                    component: () => import('@/components/Client/Dashboard/ClientTasks.vue'),
                },
                {
                    path: 'processes',
                    name: 'client-processes',
                    component: () => import('@/components/Client/Dashboard/ClientProcesses.vue'),
                },
            ],
        },
        {
            path: 'support',
            meta: {
                accountTypes: ['support'],
                breadcrumb: 'Organizations',
            },
            children: [
                {
                    path: '',
                    name: 'support-dashboard',
                    component: () => import('@/components/Admin/views/AdminProcesses.vue'),
                },
                {
                    path: 'organizations',
                    name: 'support-organizations',
                    component: () => import('@/components/Admin/views/AdminOrganizations.vue'),
                },
                {
                    path: 'entities',
                    name: 'support-entities',
                    component: () => import('@/components/Admin/views/AdminEntities.vue'),
                },
                {
                    path: 'subscriptions',
                    name: 'support-subscriptions',
                    component: () => import('@/components/Admin/views/AdminSubscriptions.vue'),
                },
                {
                    path: 'leads',
                    name: 'support-leads',
                    component: () => import('@/components/Admin/views/AdminLeads.vue'),
                },
            ],
        },
        {
            path: 'notary',
            meta: {
                accountTypes: ['notary', 'support'],
                breadcrumb: 'Organizations',
            },
            children: [
                {
                    path: '',
                    name: 'notary-dashboard',
                    component: () => import('@/components/Admin/views/AdminProcesses.vue'),
                },
                {
                    path: 'entities',
                    name: 'notary-entities',
                    component: () => import('@/components/Admin/views/AdminEntities.vue'),
                },
            ],
        },
        {
            path: 'advisor',
            component: () => import('../views/Advisor/AdvisorDashboardView.vue'),
            meta: {
                accountTypes: ['bookkeeper', 'support'],
                breadcrumb: 'Organizations',
            },
            children: [
                {
                    path: '',
                    name: 'advisor-dashboard',
                    component: () => import('@/components/Client/Dashboard/ClientDashboard.vue'),
                },
                {
                    path: 'processes',
                    name: 'advisor-jobs',
                    component: () => import('@/components/Admin/views/AdminProcesses.vue'),
                },
                {
                    path: 'organizations',
                    name: 'advisor-organizations',
                    component: () => import('@/components/Admin/views/AdminOrganizations.vue'),
                },
                {
                    path: 'entities',
                    name: 'advisor-entities',
                    component: () => import('@/components/Admin/views/AdminEntities.vue'),
                },
                {
                    path: 'leads',
                    name: 'advisor-leads',
                    component: () => import('@/components/Advisor/views/AdvisorLeads.vue'),
                },
                {
                    path: 'contracts',
                    name: 'advisor-contracts',
                    component: () => import('@/components/Client/Dashboard/Contracts/ContractsOverview.vue'),
                },
                {
                    path: 'templates',
                    name: 'advisor-templates',
                    component: () => import('@/components/Client/Dashboard/ClientTemplates.vue'),
                },
            ],
        },
    ],
};
